import { render, staticRenderFns } from "./PPI_SHOOT1.vue?vue&type=template&id=5235e490&scoped=true&"
import script from "./PPI_SHOOT1.vue?vue&type=script&lang=js&"
export * from "./PPI_SHOOT1.vue?vue&type=script&lang=js&"
import style0 from "./PPI_SHOOT1.vue?vue&type=style&index=0&id=5235e490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235e490",
  null
  
)

export default component.exports